__turbopack_context__.v({
  "closing": "user-location-module-scss-module__Wb1BIW__closing",
  "icon": "user-location-module-scss-module__Wb1BIW__icon",
  "location-search-container": "user-location-module-scss-module__Wb1BIW__location-search-container",
  "mini-icon": "user-location-module-scss-module__Wb1BIW__mini-icon",
  "slide-down": "user-location-module-scss-module__Wb1BIW__slide-down",
  "slide-up": "user-location-module-scss-module__Wb1BIW__slide-up",
});
